import { UploadOriginEnum } from '@/types/generated'

export const uploadOriginsDE = {
  [UploadOriginEnum.NONE]: 'Keine',
  [UploadOriginEnum.CHATBOT_UPLOAD]: 'Chatbot Upload',
  [UploadOriginEnum.EMAIL_ANHANG]: 'Email Anhang',
  [UploadOriginEnum.TERMINBUCHUNG]: 'Terminbuchung',
  [UploadOriginEnum.FRAGEBOGEN]: 'Fragebogen',
  [UploadOriginEnum.MANUELL_HINZUGEFÜGT]: 'Manuell hinzugefügt',
  [UploadOriginEnum.AI_CASE_CHAT]: 'KI Chat',
  [UploadOriginEnum.EXTERNAL_PLATFORM]: 'Externe Plattform'
}

export const uploadOriginsEN = {
  [UploadOriginEnum.NONE]: 'None',
  [UploadOriginEnum.CHATBOT_UPLOAD]: 'Chatbot upload',
  [UploadOriginEnum.EMAIL_ANHANG]: 'Email attachment',
  [UploadOriginEnum.TERMINBUCHUNG]: 'Appointment booking',
  [UploadOriginEnum.FRAGEBOGEN]: 'Questionnaire',
  [UploadOriginEnum.MANUELL_HINZUGEFÜGT]: 'Manually added',
  [UploadOriginEnum.AI_CASE_CHAT]: 'AI Chat',
  [UploadOriginEnum.EXTERNAL_PLATFORM]: 'External platform'
}
